import { Typography } from "@mui/material"

export function FieldTypography({ text, color = "text.secondary" }) {
    return (
        <Typography variant="body2" fontStyle="italic" align="center" color={color} sx={{ fontSize: 13 }}>
            {text}
        </Typography>
    )
}
